import BaseAction from "./BaseAction";
import CustomerReviewFiltersReducer from "@common/redux/reducers/CustomerReviewFiltersReducer";

class CustomerReviewFiltersAction extends BaseAction {}

const action = new CustomerReviewFiltersAction(CustomerReviewFiltersReducer);
export default action;
